<template>
<div class="card position-relative overflow-auto">
	<div class="dash-card-header"> 
		<div class="back-link ml-3">
			<button @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg">	
			</button>
		</div>
		<div class="title-div font-semibold"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("Password Reset")}}</div>
	</div>		
	<div class="login-form">
		<div class="form-group">
			<input type="email" class="form-control bg-color-grblue-border" name="email" aria-describedby="emailHelp" placeholder="Email" v-model="form.email">
		</div>
		<div v-if="error"  class="form-group col-sm-12">
			<div class=" btn-danger p-8" ref="errormsg">{{error}}</div>
		</div>
		<div v-if="error1"  class="form-group col-sm-12">
			<div class=" btn-warning p-8" ref="errormsg">{{error1}}</div>
		</div>
		<div v-if="message"  class="form-group col-sm-12">
			<div class=" btn-success p-8" ref="errormsg">{{message}}</div>
		</div>
		<button @click="forgotPassword" type="submit" class="form-control btn bg-color-grblue">{{$t("Send Reset Link")}}</button>
	</div>
	<div class="bottom-txt-login col-sm-12"> 
		<div class="mb-5 p-4"> 
			<router-link :to="{name: 'login'}">{{$t("Back to Login")}}</router-link>
		</div>
		{{$t("Don't have an account yet?")}}
		<p>
		<router-link class="bottom-text-login-a " :to="{name: 'register'}">
			{{$t("Register here")}}
		</router-link>
		</p>
	</div>
</div>
</template>

<script>

export default {
	name: "Forgot Password",
	data() {
		return{
			form:{
				email: '',
			},
			error: '',
			error1: '',
			message: ''
		}
    },
	mounted() {
	},
    methods:{
		hasHistory () { return window.history.length > 2 },
        async forgotPassword(){ 
             this.error = null;
			try {
				await this.$store.dispatch('forgotPassword', this.form).then( res => {
					if (!res.success) {
						this.error1 = this.$t('When your account exists, you will receive an email to reset your password.')
					} else {
						this.message = res.message
					}
				
					setTimeout(async () => {
						await this.$router.push({ name: 'home' });
					}, 3500)					
				});
			} catch (error) {  
				if(error.response.data && error.response.data.message)
					this.error = error.response.data.message;
				else
					this.error = this.$t('Something went wrong. Try again later.')
			} 
         },
    }
}

</script>